@import "~@uipath/apollo-core/src/scss/base-host.scss";

@import "../../utils/mixins/mixins.scss";

.portal-button {
  @include portal-button();
}

.skip-content {
  position: absolute;
  z-index: 100;
  transform: translateY(-100%);
  transition: transform 0.3s;
  opacity: 0;

  &:focus {
    transform: translateY(0);
    opacity: 1;
  }
}
